import React from "react";
import "./Footer.css";
import {
  InstagramOutlined,
  FacebookOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { Form, Input, Button, message } from "antd";
const Footer = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    console.log("Submitted Values:", values);
    message.success("Your query has been submitted!");
    form.resetFields(); // Reset form fields after submission
  };
  return (
    <div className="footer-container">
      <div
        style={{
          display: "flex",
          gap: "20px",
          justifyContent: "center",
          padding: "20px",
          height:"10vh"
        }}
      >
        <a
          href="https://www.instagram.com/abomed.in?igsh=MW1ldzA3M2Q0NGNkMw=="
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          style={{ textDecoration: "none" }}
        >
          <InstagramOutlined style={{ fontSize: "32px", color: "#C13584" }} />
        </a>

        {/* Email */}
        <a
          href="mailto:info@abomed.in"
          aria-label="Email"
          style={{ textDecoration: "none" }}
        >
          <MailOutlined style={{ fontSize: "32px", color: "#D44638" }} />
        </a>

        {/* Phone */}
        <a
          href="tel:+1234567890"
          aria-label="Phone"
          style={{ textDecoration: "none" }}
        >
          <PhoneOutlined style={{ fontSize: "32px", color: "#34A853" }} />
        </a>
      </div>
      <div style={{ maxWidth: "500px", margin: "0 auto", padding: "20px" }}>
        <h2 style={{ textAlign: "center" }}>Contact Us</h2>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{
            background: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Email Input */}
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email address" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>

          {/* Textarea Input */}
          <Form.Item
            label="Your Query"
            name="query"
            rules={[{ required: true, message: "Please enter your query" }]}
          >
            <Input.TextArea rows={4} placeholder="Write your query here..." />
          </Form.Item>

          {/* Submit Button */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              style={{ fontSize: "16px" }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div style={{width:"100%",backgroundColor:"#004D40",marginTop:"10px"}}>
            <p style={{lineHeight:"30px", color:"white", textAlign:"center"}}>© 2025. All rights reserved.</p>
        </div>
    </div>
  );
};

export default Footer;
